var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpeedMeter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 36,
    viewBox: "0 0 32 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_270_17788)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1503 2C14.2777 2.01415 12.4264 2.39701 10.7018 3.12673C8.9773 3.85645 7.41341 4.91872 6.09945 6.25289C4.78549 7.58705 3.7472 9.167 3.04389 10.9025C2.34057 12.6379 1.986 14.4949 2.00042 16.3674V18.9798C2.00042 19.4802 2.1992 19.9601 2.55301 20.3139C2.90683 20.6677 3.3867 20.8665 3.88707 20.8665H28.4135C28.9138 20.8665 29.3937 20.6677 29.7476 20.3139C30.1014 19.9601 30.3001 19.4802 30.3001 18.9798V16.3637C30.3283 12.5826 28.8533 8.94525 26.1997 6.25156C23.5462 3.55789 19.9314 2.02858 16.1503 2Z",
    stroke: "#008600",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.377 20.865V19.9217C12.377 18.921 12.7745 17.9612 13.4821 17.2536C14.1898 16.546 15.1496 16.1484 16.1502 16.1484C17.1509 16.1484 18.1107 16.546 18.8183 17.2536C19.526 17.9612 19.9235 18.921 19.9235 19.9217V20.865",
    stroke: "#008600",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4789 10.0083L18.1527 15.9867",
    stroke: "#008600",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.18846 16.1504C6.92796 16.1504 6.7168 15.9392 6.7168 15.6787C6.7168 15.4182 6.92796 15.207 7.18846 15.207",
    stroke: "#008600",
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.18848 16.1504C7.44897 16.1504 7.66014 15.9392 7.66014 15.6787C7.66014 15.4182 7.44897 15.207 7.18848 15.207",
    stroke: "#008600",
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8486 9.66403C10.5881 9.66403 10.377 9.45286 10.377 9.19236C10.377 8.93187 10.5881 8.7207 10.8486 8.7207",
    stroke: "#008600",
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8486 9.66403C11.1091 9.66403 11.3203 9.45286 11.3203 9.19236C11.3203 8.93187 11.1091 8.7207 10.8486 8.7207",
    stroke: "#008600",
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8486 7.66403C17.5881 7.66403 17.377 7.45286 17.377 7.19236C17.377 6.93187 17.5881 6.7207 17.8486 6.7207",
    stroke: "#008600",
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8486 7.66403C18.1091 7.66403 18.3203 7.45286 18.3203 7.19236C18.3203 6.93187 18.1091 6.7207 17.8486 6.7207",
    stroke: "#008600",
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1113 16.1542C24.8508 16.1542 24.6396 15.943 24.6396 15.6825C24.6396 15.422 24.8508 15.2109 25.1113 15.2109",
    stroke: "#008600",
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1113 16.1542C25.3718 16.1542 25.583 15.943 25.583 15.6825C25.583 15.422 25.3718 15.2109 25.1113 15.2109",
    stroke: "#008600",
    strokeWidth: 2.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_270_17788"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 22,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedMeter);
export default __webpack_public_path__ + "static/media/SpeedMeter.ee7aff75558c51a3f853d795ec453ecf.svg";
export { ForwardRef as ReactComponent };